export default "__VITE_ASSET__cf0e16bb__"